module.exports = __webpack_public_path__ + "img/EMT-LICA_GSE146409.d6e4d13a.png";